import { Component } from '@angular/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { ViewportOverlayDirective } from '../../common/directives/viewport-overlay/viewport-overlay.directive';

@Component({
  selector: 'atom-deleting-overlay',
  standalone: true,
  imports: [LottieComponent],
  hostDirectives: [ViewportOverlayDirective],
  templateUrl: './deleting-overlay.component.html',
  styleUrl: './deleting-overlay.component.scss',
})
export class DeletingOverlayComponent {
  readonly options: AnimationOptions = {
    path: 'assets/lottie/delete_bin.json',
    loop: true,
    autoplay: true,
  };
}
